export default __webpack_public_path__ + "static/media/copy-dark.07df7180.svg";